import { useAuth0 } from "@auth0/auth0-react";
import { LuLogOut } from "react-icons/lu";
import { Link } from "react-router";
import styled from "styled-components";

import BIMProjectLogo from "../components/BIMProjectLogo";

const Overlay = styled.div`
    bottom: 32px;
    right: 32px;
    position: fixed;
    z-index: 999;
`;

const Menu = styled.div`
    --menu-outline: 0px;

    background: #000c;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    gap: 4px;

    &::before {
        background: transparent;
        border-radius: 4px;
        bottom: var(--menu-outline);
        content: "";
        left: var(--menu-outline);
        position: absolute;
        right: var(--menu-outline);
        top: var(--menu-outline);
        transition: 200ms;
        z-index: -1;
    }

    //&:hover {
    //    --outline: -1px;
    //
    //    &::before {
    //        background: #fff5;
    //    }
    //}

    button {
        align-items: center;
        background: transparent;
        border: none;
        color: #fff;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        gap: 4px;
        justify-content: center;
        padding: 0 12px;

        &:hover {
            opacity: .8;
        }
    }

    &:not(:hover) button {
        display: none;
    }
`;

const IndexLink = styled(Link)`
    align-items: center;
    background: #000;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    height: 40px;
    justify-content: center;
    width: 48px;

    svg {
        color: #fff;
        max-height: 24px;
        max-width: 24px;
    }
`;

export default function OverlayMenu() {
    const auth0 = useAuth0();

    function logout() {
        auth0.logout(
            {
                logoutParams: {
                    returnTo: window.location.origin,
                },
            }
        );
    }

    return (
        <Overlay>
            <Menu>
                {
                    auth0.isAuthenticated && (
                        <button
                            onClick={ logout }
                            title="logout"
                        >
                            <LuLogOut />
                            <span>sign out { auth0.user.email }</span>
                        </button>
                    )
                }
                <IndexLink to="/">
                    <BIMProjectLogo />
                </IndexLink>
            </Menu>
        </Overlay>
    );
}
